import React, { useState, useEffect } from 'react';
import { Search, Trophy, SlidersHorizontal } from 'lucide-react';
import SectionHero from '../Layouts/SectionHero';
import { getTournaments } from '../../api/wikiApi';
import { TournamentCard } from './TournamentElements';
import { sortTournaments, isCurrent } from './tournamentPresentation';
import styles from './TournamentExperience.module.css';

export default function TournamentsListPage() {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  useEffect(() => {
    let active = true;
    getTournaments().then((data) => { if (active) setTournaments(Array.isArray(data) ? data : []); })
      .catch(() => { if (active) setError('Не удалось загрузить турниры. Попробуйте обновить страницу.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  const visible = sortTournaments(tournaments);
  const currentCount = visible.filter(isCurrent).length;
  const finishedCount = visible.filter((t) => t.status === 'finished').length;
  const filtered = visible.filter((t) => (filter === 'all' || (filter === 'current' ? isCurrent(t) : t.status === 'finished'))
    && t.title.toLocaleLowerCase('ru').includes(search.trim().toLocaleLowerCase('ru')));
  const showFeatured = filter === 'all' && !search.trim();
  const featured = showFeatured ? filtered[0] : null;
  const rest = featured ? filtered.slice(1) : filtered;

  return <div className={styles.page}>
    <SectionHero eyebrow="Соревнуйся. Побеждай. Запоминайся." title="Турниры." highlight="Твой выход на арену."
      description="Большие победы начинаются здесь. Следи за соревнованиями, изучай сетки и узнавай, кто вписал своё имя в историю InterWorld." />
    <main className={styles.body}>
      {loading ? <div className={styles.state} role="status"><div className={styles.spinner} />Загружаем арену…</div>
        : error ? <div className={styles.state} role="alert">{error}</div>
        : <>
          <div className={styles.toolbar}>
            <div className={styles.filters} role="group" aria-label="Статус турнира">
              {[['all', 'Все турниры', visible.length], ['current', 'Актуальные', currentCount], ['finished', 'Завершённые', finishedCount]].map(([key, label, count]) =>
                <button key={key} type="button" aria-pressed={filter === key} onClick={() => setFilter(key)}>{label}<span>{count}</span></button>)}
            </div>
            <label className={styles.search}><Search size={18} /><input aria-label="Поиск турнира" placeholder="Найти турнир…" value={search} onChange={(e) => setSearch(e.target.value)} type="search" /></label>
          </div>
          {featured && <TournamentCard tournament={featured} featured />}
          {rest.length > 0 && <section className={styles.archive} aria-label="Список турниров">
            <div className={styles.sectionHeading}><div><span className={styles.eyebrow}>Сражения, которые помнят</span><h2>{featured && !currentCount ? 'История турниров' : 'Турниры InterWorld'}</h2></div><span className={styles.count}>{rest.length}</span></div>
            <div className={styles.cardGrid}>{rest.map((t) => <TournamentCard key={t.id} tournament={t} />)}</div>
          </section>}
          {!filtered.length && <div className={styles.state}>
            {search ? <SlidersHorizontal size={36} /> : <Trophy size={40} />}
            <h2>{search ? 'Ничего не найдено' : filter === 'current' ? 'Арена ждёт новых героев' : 'Турниров пока нет'}</h2>
            <p>{search ? 'Попробуй другое название или сбрось фильтры.' : filter === 'current' ? 'Сейчас нет открытых турниров. А прошлые победы уже ждут тебя в архиве.' : 'Здесь появятся анонсы, участники и результаты соревнований.'}</p>
            {(search || filter !== 'all') && <button className={styles.button} onClick={() => { setSearch(''); setFilter('all'); }}>Показать все турниры</button>}
          </div>}
        </>}
    </main>
  </div>;
}
